var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"accent"}})],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }